// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.upgrade-plan-dialog {
  width: 100%;
  max-width: min(760px, 100%);
  box-sizing: border-box;
  padding: 1.35rem 1.4rem 1.5rem;
  max-height: min(90vh, 900px);
  max-height: min(90dvh, 900px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}
.dialog-header .eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5ea1d8;
}
.dialog-header h2 {
  margin: 0.25rem 0 0.35rem;
  font-size: 1.35rem;
  color: #0f172a;
}
.dialog-header .subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.45;
  max-width: 520px;
}

.close-btn {
  border: none;
  background: #f1f5f9;
  border-radius: 999px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  flex-shrink: 0;
}

.billing-toggle-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}
.billing-toggle-row .billing-label {
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
}
.billing-toggle-row .billing-label.active {
  color: #0f172a;
  font-weight: 600;
}
.billing-toggle-row .billing-label .discount-badge {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  background-color: #dcfce7;
  color: #16a34a;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 9999px;
  margin-left: 0.35rem;
}
.billing-toggle-row .billing-toggle {
  position: relative;
  width: 3rem;
  height: 1.5rem;
  background-color: #cbd5e1;
  border: none;
  border-radius: 9999px;
  padding: 0.2rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.billing-toggle-row .billing-toggle.active {
  background-color: #5ea1d8;
}
.billing-toggle-row .billing-toggle.active .toggle-dot {
  transform: translateX(1.5rem);
}
.billing-toggle-row .billing-toggle .toggle-dot {
  width: 1.1rem;
  height: 1.1rem;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  display: block;
}

.plan-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.85rem;
}
@media (min-width: 700px) {
  .plan-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.plan-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
  text-align: left;
  padding: 1.1rem 1rem 1rem;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
}
.plan-card.featured {
  border-color: #e83e8c;
  box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.15);
}
.plan-card .badge {
  position: absolute;
  top: -0.55rem;
  right: 0.65rem;
  background: #e83e8c;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
}
.plan-card .plan-name {
  font-weight: 700;
  color: #0f172a;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.plan-card .plan-price {
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f172a;
}
.plan-card .plan-price .plan-period {
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
}
.plan-card .plan-price .billing-note {
  display: block;
  font-size: 0.68rem;
  font-weight: 500;
  color: #64748b;
}
.plan-card .plan-audience {
  font-size: 0.78rem;
  color: #64748b;
  min-height: 2.2em;
}
.plan-card .plan-features {
  list-style: none;
  padding: 0;
  margin: 0.4rem 0 0.85rem;
  flex-grow: 1;
}
.plan-card .plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: #0f172a;
  margin-bottom: 0.45rem;
}
.plan-card .plan-features li .check-icon {
  flex-shrink: 0;
  font-size: 0.95rem;
  width: 0.95rem;
  height: 0.95rem;
  line-height: 1.2;
  color: #5ea1d8;
}
.plan-card .plan-cta {
  width: 100%;
  padding: 0.6rem;
  font-weight: 700;
  font-size: 0.82rem;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  background: #0f172a;
  color: #fff;
  transition: opacity 0.15s ease;
}
.plan-card .plan-cta:hover {
  opacity: 0.9;
}
.plan-card .plan-cta.accent {
  background: #e83e8c;
}
.plan-card .plan-cta.outline {
  background: #fff;
  border-color: #cbd5e1;
  color: #0f172a;
}
.plan-card .plan-cta.outline:hover {
  border-color: #0f172a;
  opacity: 1;
}

.dialog-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
  margin-top: 1.15rem;
}

.btn-link {
  border: none;
  background: none;
  padding: 0;
  text-align: left;
  color: #5ea1d8;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-cancel {
  align-self: flex-end;
  border-radius: 8px;
  padding: 0.6rem 1.1rem;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
  border: 1px solid #cbd5e1;
  color: #0f172a;
}

/* Mobile */
@media (max-width: 640px) {
  .upgrade-plan-dialog {
    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));
    max-height: calc(100vh - 16px);
    max-height: calc(100dvh - 16px);
    border-radius: 16px;
  }
  .dialog-header {
    gap: 0.65rem;
    margin-bottom: 0.85rem;
  }
  .dialog-header h2 {
    font-size: 1.15rem;
  }
  .dialog-header .subtitle {
    font-size: 0.82rem;
    max-width: none;
  }
  .close-btn {
    width: 32px;
    height: 32px;
  }
  .billing-toggle-row {
    flex-wrap: wrap;
    gap: 0.5rem 0.65rem;
    margin-bottom: 1rem;
    justify-content: center;
  }
  .billing-toggle-row .billing-label {
    font-size: 0.8rem;
  }
  .billing-toggle-row .billing-label .discount-badge {
    display: inline-block;
    margin-left: 0.25rem;
    font-size: 0.62rem;
  }
  .plan-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  .plan-card {
    padding: 1rem 0.85rem 0.9rem;
  }
  .plan-card .plan-price {
    font-size: 1.2rem;
  }
  .plan-card .plan-features li {
    font-size: 0.78rem;
  }
  .dialog-actions {
    margin-top: 1rem;
    gap: 0.65rem;
  }
  .btn-link {
    text-align: center;
    font-size: 0.85rem;
  }
  .btn-cancel {
    align-self: stretch;
    width: 100%;
    min-height: 44px;
  }
}
/* Dark mode — upgrade / subscription plans modal */
:host-context(body.theme-dark) .upgrade-plan-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-header .eyebrow {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .dialog-header h2 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .dialog-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .close-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .close-btn mat-icon,
:host-context(body.theme-dark) .close-btn .mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .billing-toggle-row .billing-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .billing-toggle-row .billing-label.active {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .billing-toggle-row .billing-label .discount-badge {
  background-color: #166534 !important;
  color: #dcfce7 !important;
}
:host-context(body.theme-dark) .billing-toggle-row .billing-toggle {
  background-color: #334155 !important;
}
:host-context(body.theme-dark) .billing-toggle-row .billing-toggle.active {
  background-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .plan-card {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .plan-card.featured {
  border-color: #e83e8c !important;
  box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.25) !important;
}
:host-context(body.theme-dark) .plan-card .plan-name,
:host-context(body.theme-dark) .plan-card .plan-price {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .plan-card .plan-price .plan-period,
:host-context(body.theme-dark) .plan-card .plan-price .billing-note,
:host-context(body.theme-dark) .plan-card .plan-audience {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .plan-card .plan-features li {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .plan-card .plan-features li .check-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .plan-card .plan-cta {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .plan-card .plan-cta.outline {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .plan-card .plan-cta.outline:hover {
  border-color: #93c5fd !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .btn-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .btn-cancel {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
  color: #e2e8f0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/upgrade-plan-dialog/upgrade-plan-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMhB;EACE,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAJF;AAME;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA/BY;AA2BhB;AAOE;EACE,yBAAA;EACA,kBAAA;EACA,cAnCQ;AA8BZ;AAQE;EACE,SAAA;EACA,cAvCS;EAwCT,iBAAA;EACA,iBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AAPF;AASE;EACE,kBAAA;EACA,gBAAA;EACA,cAtES;AA+Db;AASI;EACE,cA1EM;EA2EN,gBAAA;AAPN;AAUI;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AARN;AAYE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAVJ;AAYI;EACE,yBAxGU;AA8FhB;AAYM;EACE,6BAAA;AAVR;AAcI;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;EACA,cAAA;AAZN;;AAiBA;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AAdF;AAgBE;EALF;IAMI,qCAAA;EAbF;AACF;;AAgBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAbF;AAeE;EACE,qBAjJW;EAkJX,8CAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAzJW;EA0JX,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,cAnKQ;EAoKR,eAAA;EACA,yBAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,gBAAA;EACA,cA5KQ;AA4JZ;AAkBI;EACE,kBAAA;EACA,gBAAA;EACA,cAhLO;AAgKb;AAmBI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAvLO;AAsKb;AAqBE;EACE,kBAAA;EACA,cA7LS;EA8LT,iBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,UAAA;EACA,wBAAA;EACA,YAAA;AApBJ;AAsBI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,cA7MM;EA8MN,sBAAA;AApBN;AAsBM;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAxNQ;AAoMhB;AAyBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAnOQ;EAoOR,WAAA;EACA,8BAAA;AAvBJ;AAyBI;EACE,YAAA;AAvBN;AA0BI;EACE,mBA7OS;AAqNf;AA2BI;EACE,gBAAA;EACA,qBAAA;EACA,cAlPM;AAyNZ;AA2BM;EACE,qBArPI;EAsPJ,UAAA;AAzBR;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,cA3Qc;EA4Qd,gBAAA;EACA,eAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAvRU;AA2PZ;;AA+BA,WAAA;AACA;EACE;IACE,kEAAA;IACA,8BAAA;IACA,+BAAA;IACA,mBAAA;EA5BF;EA+BA;IACE,YAAA;IACA,sBAAA;EA7BF;EA+BE;IACE,kBAAA;EA7BJ;EAgCE;IACE,kBAAA;IACA,eAAA;EA9BJ;EAkCA;IACE,WAAA;IACA,YAAA;EAhCF;EAmCA;IACE,eAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;EAjCF;EAmCE;IACE,iBAAA;EAjCJ;EAmCI;IACE,qBAAA;IACA,oBAAA;IACA,kBAAA;EAjCN;EAsCA;IACE,0BAAA;IACA,YAAA;EApCF;EAuCA;IACE,4BAAA;EArCF;EAuCE;IACE,iBAAA;EArCJ;EAwCE;IACE,kBAAA;EAtCJ;EA0CA;IACE,gBAAA;IACA,YAAA;EAxCF;EA2CA;IACE,kBAAA;IACA,kBAAA;EAzCF;EA4CA;IACE,mBAAA;IACA,WAAA;IACA,gBAAA;EA1CF;AACF;AA6CA,mDAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AA5CJ;AAgDI;EACE,yBAAA;AA9CN;AAiDI;EACE,yBAAA;AA/CN;AAkDI;EACE,yBAAA;AAhDN;AAoDE;EACE,8BAAA;EACA,yBAAA;AAlDJ;AAoDI;;EAEE,yBAAA;AAlDN;AAuDI;EACE,yBAAA;AArDN;AAuDM;EACE,yBAAA;AArDR;AAwDM;EACE,oCAAA;EACA,yBAAA;AAtDR;AA0DI;EACE,oCAAA;AAxDN;AA0DM;EACE,oCAAA;AAxDR;AA6DE;EACE,8BAAA;EACA,kDAAA;AA3DJ;AA6DI;EACE,gCAAA;EACA,yDAAA;AA3DN;AA8DI;;EAEE,yBAAA;AA5DN;AA+DI;;;EAGE,yBAAA;AA7DN;AAgEI;EACE,yBAAA;AA9DN;AAgEM;EACE,yBAAA;AA9DR;AAkEI;EACE,yBAAA;AAhEN;AAkEM;EACE,kCAAA;EACA,kDAAA;EACA,yBAAA;AAhER;AAkEQ;EACE,gCAAA;EACA,yBAAA;AAhEV;AAsEE;EACE,yBAAA;AApEJ;AAuEE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AArEJ","sourcesContent":["$primary-color: #5ea1d8;\n$accent-color: #e83e8c;\n$text-dark: #0f172a;\n$text-light: #64748b;\n$border-color: #e2e8f0;\n\n.upgrade-plan-dialog {\n  width: 100%;\n  max-width: min(760px, 100%);\n  box-sizing: border-box;\n  padding: 1.35rem 1.4rem 1.5rem;\n  max-height: min(90vh, 900px);\n  max-height: min(90dvh, 900px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1rem;\n\n  .eyebrow {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: $primary-color;\n  }\n\n  h2 {\n    margin: 0.25rem 0 0.35rem;\n    font-size: 1.35rem;\n    color: $text-dark;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: $text-light;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    max-width: 520px;\n  }\n}\n\n.close-btn {\n  border: none;\n  background: #f1f5f9;\n  border-radius: 999px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.billing-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n\n  .billing-label {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: $text-light;\n\n    &.active {\n      color: $text-dark;\n      font-weight: 600;\n    }\n\n    .discount-badge {\n      display: inline-block;\n      padding: 0.1rem 0.45rem;\n      background-color: #dcfce7;\n      color: #16a34a;\n      font-size: 0.7rem;\n      font-weight: 700;\n      border-radius: 9999px;\n      margin-left: 0.35rem;\n    }\n  }\n\n  .billing-toggle {\n    position: relative;\n    width: 3rem;\n    height: 1.5rem;\n    background-color: #cbd5e1;\n    border: none;\n    border-radius: 9999px;\n    padding: 0.2rem;\n    cursor: pointer;\n    transition: background-color 0.2s;\n\n    &.active {\n      background-color: $primary-color;\n\n      .toggle-dot {\n        transform: translateX(1.5rem);\n      }\n    }\n\n    .toggle-dot {\n      width: 1.1rem;\n      height: 1.1rem;\n      background-color: white;\n      border-radius: 50%;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n      transition: transform 0.2s;\n      display: block;\n    }\n  }\n}\n\n.plan-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.85rem;\n\n  @media (min-width: 700px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.plan-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.3rem;\n  text-align: left;\n  padding: 1.1rem 1rem 1rem;\n  border-radius: 12px;\n  border: 2px solid $border-color;\n  background: #fff;\n\n  &.featured {\n    border-color: $accent-color;\n    box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.15);\n  }\n\n  .badge {\n    position: absolute;\n    top: -0.55rem;\n    right: 0.65rem;\n    background: $accent-color;\n    color: #fff;\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding: 0.15rem 0.45rem;\n    border-radius: 999px;\n  }\n\n  .plan-name {\n    font-weight: 700;\n    color: $text-dark;\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .plan-price {\n    font-size: 1.35rem;\n    font-weight: 800;\n    color: $text-dark;\n\n    .plan-period {\n      font-size: 0.85rem;\n      font-weight: 500;\n      color: $text-light;\n    }\n\n    .billing-note {\n      display: block;\n      font-size: 0.68rem;\n      font-weight: 500;\n      color: $text-light;\n    }\n  }\n\n  .plan-audience {\n    font-size: 0.78rem;\n    color: $text-light;\n    min-height: 2.2em;\n  }\n\n  .plan-features {\n    list-style: none;\n    padding: 0;\n    margin: 0.4rem 0 0.85rem;\n    flex-grow: 1;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.4rem;\n      font-size: 0.8rem;\n      color: $text-dark;\n      margin-bottom: 0.45rem;\n\n      .check-icon {\n        flex-shrink: 0;\n        font-size: 0.95rem;\n        width: 0.95rem;\n        height: 0.95rem;\n        line-height: 1.2;\n        color: $primary-color;\n      }\n    }\n  }\n\n  .plan-cta {\n    width: 100%;\n    padding: 0.6rem;\n    font-weight: 700;\n    font-size: 0.82rem;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    background: $text-dark;\n    color: #fff;\n    transition: opacity 0.15s ease;\n\n    &:hover {\n      opacity: 0.9;\n    }\n\n    &.accent {\n      background: $accent-color;\n    }\n\n    &.outline {\n      background: #fff;\n      border-color: #cbd5e1;\n      color: $text-dark;\n\n      &:hover {\n        border-color: $text-dark;\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.dialog-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.75rem;\n  margin-top: 1.15rem;\n}\n\n.btn-link {\n  border: none;\n  background: none;\n  padding: 0;\n  text-align: left;\n  color: $primary-color;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.btn-cancel {\n  align-self: flex-end;\n  border-radius: 8px;\n  padding: 0.6rem 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  color: $text-dark;\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .upgrade-plan-dialog {\n    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));\n    max-height: calc(100vh - 16px);\n    max-height: calc(100dvh - 16px);\n    border-radius: 16px;\n  }\n\n  .dialog-header {\n    gap: 0.65rem;\n    margin-bottom: 0.85rem;\n\n    h2 {\n      font-size: 1.15rem;\n    }\n\n    .subtitle {\n      font-size: 0.82rem;\n      max-width: none;\n    }\n  }\n\n  .close-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .billing-toggle-row {\n    flex-wrap: wrap;\n    gap: 0.5rem 0.65rem;\n    margin-bottom: 1rem;\n    justify-content: center;\n\n    .billing-label {\n      font-size: 0.8rem;\n\n      .discount-badge {\n        display: inline-block;\n        margin-left: 0.25rem;\n        font-size: 0.62rem;\n      }\n    }\n  }\n\n  .plan-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .plan-card {\n    padding: 1rem 0.85rem 0.9rem;\n\n    .plan-price {\n      font-size: 1.2rem;\n    }\n\n    .plan-features li {\n      font-size: 0.78rem;\n    }\n  }\n\n  .dialog-actions {\n    margin-top: 1rem;\n    gap: 0.65rem;\n  }\n\n  .btn-link {\n    text-align: center;\n    font-size: 0.85rem;\n  }\n\n  .btn-cancel {\n    align-self: stretch;\n    width: 100%;\n    min-height: 44px;\n  }\n}\n\n/* Dark mode — upgrade / subscription plans modal */\n:host-context(body.theme-dark) {\n  .upgrade-plan-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-header {\n    .eyebrow {\n      color: #93c5fd !important;\n    }\n\n    h2 {\n      color: #f8fafc !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .close-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n\n    mat-icon,\n    .mat-icon {\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .billing-toggle-row {\n    .billing-label {\n      color: #94a3b8 !important;\n\n      &.active {\n        color: #f8fafc !important;\n      }\n\n      .discount-badge {\n        background-color: #166534 !important;\n        color: #dcfce7 !important;\n      }\n    }\n\n    .billing-toggle {\n      background-color: #334155 !important;\n\n      &.active {\n        background-color: $primary-color !important;\n      }\n    }\n  }\n\n  .plan-card {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &.featured {\n      border-color: $accent-color !important;\n      box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.25) !important;\n    }\n\n    .plan-name,\n    .plan-price {\n      color: #f8fafc !important;\n    }\n\n    .plan-price .plan-period,\n    .plan-price .billing-note,\n    .plan-audience {\n      color: #94a3b8 !important;\n    }\n\n    .plan-features li {\n      color: #e2e8f0 !important;\n\n      .check-icon {\n        color: #93c5fd !important;\n      }\n    }\n\n    .plan-cta {\n      color: #ffffff !important;\n\n      &.outline {\n        background: transparent !important;\n        border-color: rgba(148, 163, 184, 0.45) !important;\n        color: #e2e8f0 !important;\n\n        &:hover {\n          border-color: #93c5fd !important;\n          color: #93c5fd !important;\n        }\n      }\n    }\n  }\n\n  .btn-link {\n    color: #93c5fd !important;\n  }\n\n  .btn-cancel {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n    color: #e2e8f0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
